import CustomImage from '../../fragments/custom-image/CustomImage';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';

export default function HeroNews({ block, index }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? 'h1' : 'h2';

  return (
    <ComponentWrapper
      block={block}
      className={`HeroNews HeroNews--${block?.postType}`}
    >
      <div className={'l-grid'}>
        <div className="l-grid__col l-grid__col--l-8-12 ">
          <div className={`HeroNews-content`}>
            {block.category && (
              <p className="HeroNews-subheading headingStrong">
                <span>{block.category}</span>
                {block.time && <span>{block.time}</span>}
              </p>
            )}
            {block.heading && (
              <HeadingTag
                className={'HeroNews-heading h1'}
                dangerouslySetInnerHTML={{ __html: block.heading }}
              />
            )}
            {block.description && (
              <p className="HeroNews-description">{block.description}</p>
            )}
          </div>
        </div>
      </div>
      {block.image && (
        <div className="HeroNews-media">
          <CustomImage
            image={block.image}
            fill={true}
            forceLoad={true}
            parallax
            desktopWidth={100}
          />
        </div>
      )}
    </ComponentWrapper>
  );
}
